import { render } from "./ProjectsView.vue?vue&type=template&id=54e497cb&scoped=true"
import script from "./ProjectsView.vue?vue&type=script&lang=js"
export * from "./ProjectsView.vue?vue&type=script&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=54e497cb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\carlc\\portfolio\\portfolio-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e497cb"]])

export default __exports__